<template lang="pug">
	.flex-col.space-large.full-width.creative--creative-detail--newsml
		.flex-col.space-medium
			.flex-col.flex-1
				.upper.grey {{$tCaption('NewsML settings')}}
			DxCheckBox(:text="$tCaption('Is NewsML template')", :value.sync="editingCreative.IsNewsMLTemplate", :disabled="readonly")
			template(v-if="editingCreative.IsNewsMLTemplate")
				.flex-col.space-medium
					.flex-row.space-large
						.flex-col
							.font-small.upper.grey {{$tCaption('Top headline:')}}
							DxNumberBox(:value="editingCreative.JsonConfig.newsMLTopHeadline", :width="120", :disabled="readonly", stylingMode="filled", @value-changed="e => $set(editingCreative.JsonConfig, 'newsMLTopHeadline', e.value)", :show-spin-buttons="true")
						.flex-col
							.font-small.upper.grey {{$tCaption('Top content:')}}
							DxNumberBox(:value="editingCreative.JsonConfig.newsMLTopContent", :width="120", :disabled="readonly", stylingMode="filled", @value-changed="e => $set(editingCreative.JsonConfig, 'newsMLTopContent', e.value)", :show-spin-buttons="true")
				.flex-col.space 
					Loader(v-if="isLoading", text="")
					template(v-else)
						.flex-row.space(v-if="!schedule")
							DxButton(icon="plus", :text="$tCaption('New schedule')", @click="newSchedule")
						DxTabPanel.tab-panel-small(v-else, :dataSource="tabs")
							template(v-slot:title="{ data }")
								span {{data.name}}
							template(v-slot:item="{ data }")
								.tabpanel-item.padding
									ScheduleDetail(ref="scheduleDetail", :id="schedule.Oid", :editingCreative="editingCreative", :value="schedule", @removed="schedule = null")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';	
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxTabPanel from 'devextreme-vue/tab-panel';
	import Loader from 'app-core/Loader.vue';
	import ScheduleDetail from 'view/persistentSchedule/Detail.vue';

	export default {
		translationCategory: 'creative.Detail',
		name: 'creative-detail',
		components: {
			DxButton, DxNumberBox, DxCheckBox, Loader, DxTabPanel, ScheduleDetail
		},
		props: [
			'editingCreative', 'readonly'
		],

		data() {
			return {
				isLoading: false,
				schedule: null,
				tabs: [ { id: 'schedule', name: this.$tCaption('Schedule') }],
				hasChanges: false
			};
		},
		computed: {
			
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.creativeDetailNewsML = this;
			this.initNewsMLSchedule();
		},
		destroyed() {
			
		},
		methods: {
			async initNewsMLSchedule() {
				this.isLoading++;
				this.schedule = ((await this.$Data.getExternalApi('PersistentSchedule/List', `page=1&filterCriteria=["TargetObjectOid", "=", "${this.editingCreative.Oid}"]`, 1).finally(() => this.isLoading--))?.Results || [])[0];
				if (this.schedule) {
					this.$Data.processPersistentScheduleCase(this.schedule, true);
				}
			},
			async newSchedule() {
				this.isLoading++;
				let schedule = (await this.$Data.postExternalApi('PersistentSchedule/CreateUpdate', {
					Name: (this.editingCreative.RootCreativeName || this.editingCreative.Name) + ' ' + this.$tCaption('schedule'),
					TargetObjectOid: this.editingCreative.Oid,
					TargetObjectType: this.$Data.objectTypes.CreativeTemplate,
					CronExpression: '* * * * *'
				}).finally(() => this.isLoading--))?.Data;
				this.$Data.processPersistentScheduleCase(schedule, true);
				this.schedule = schedule;
			},
			async save() {
				await this.$refs.scheduleDetail.save();
			}
		},
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.creative--creative-detail--newsml {
		
	}
</style>
